import './user_sentiment.css';
import { h, Component } from 'preact';
import { IoMdThumbsDown, IoMdThumbsUp } from 'react-icons/io';
import { BaseAnnotation } from '../base_annotation';
import { safelyGetBCR } from 'utilities/dom';
import elementClosestPolyfill from 'element-closest';

elementClosestPolyfill(window);

class UserSentiment extends BaseAnnotation {
    constructor(props) {
        super(props);

        this.state = {
            timesClicked: 0,
            lastClickedValue: null
        }
    }

    customEventData = () => {
        const {timesClicked, lastClickedValue} = this.state;

        return {
            counter: timesClicked,
            image: lastClickedValue === 'like' ? 'thumb_up' : 'thumb_down',
            maxRating: 5,
            minRating: 1,
            mode: 'thumbs',
            rating: lastClickedValue === 'like' ? 5 : 1,
            widgetPositionSimple: 'CONTROL_BAR'
        };
    }

    createAnimation = ({ el, property, value, delay, fn }) => {
        setTimeout(() => {
            if (property && value) el.style[property] = value;

            if (fn && fn === 'remove') {
                el.parentElement.removeChild(el);
            }
        }, delay);
    }

    animate = (target) => {
        const targetDiv = target.closest('div.thumb');
        const clonedNode = targetDiv && targetDiv.cloneNode(true);
        const parentControlBar = target.closest('.vjs-control-bar');
        const floatHeight = parentControlBar.offsetHeight * 4;

        if (!clonedNode.classList.contains('thumb')) {
            return;
        }

        clonedNode.style.top = 0;
        clonedNode.style.right = safelyGetBCR(parentControlBar).right - safelyGetBCR(target).right - 3 + 'px';
        clonedNode.classList.add('usersentiment-cloned');
        parentControlBar.appendChild(clonedNode);

        [{ el: clonedNode, property: 'top', value: (-1 * floatHeight) + 'px', delay: 10 },
         {el: clonedNode, property: 'opacity', value: 0, delay: 0},
         {el: clonedNode, value: 0, delay: 2000, fn: 'remove'}
        ].forEach((data) => this.createAnimation(data));
    }

    get actions() {
        return [{event: 'Click'}];
    }

    get defaultState() {
        return this.customEventData();
    }

    handleClick = (val, evt) => {
        const {timesClicked} = this.state;

        this.setState({timesClicked: timesClicked + 1, lastClickedValue: val}, () => {
            this.onAction('Click');
            this.animate(evt.target);
        });
    }

    render () {
        return (
            /* need to use div instead of button due to IE event capture limitations 😠 */
            <div className='vjs-control vjs-button usersentiment'>
                <div className='thumb' onClick={this.handleClick.bind(this, 'like')} data-val='like'><IoMdThumbsUp className='thumb'/></div>
                <div className='thumb' onClick={this.handleClick.bind(this, 'dislike')} data-val='dislike'><IoMdThumbsDown className='thumb'/></div>
            </div>    
        )
    }
}

export {UserSentiment};